// import axios from 'axios';
import { axiosImagePrivate } from "../api/axiosapi";
import { useEffect } from "react";
import useRefreshToken from "./useRefreshToken";
import useAuth from "./useAuth";

// const axiosPrivate = axios.create({
// 	// 요청 설정
// 	baseURL: 'https://develop.tiffmath.kr/api',
// 	// timeout: 10000,
// 	headers: {
// 		'Content-Type': 'application/json',
// 		// 추가적인 헤더 설정 가능
// 	}
// });

const useAxiosImagePrivate = () => {
    const refresh = useRefreshToken();
    const { auth } = useAuth();

    useEffect(() => {

        const requestIntercept = axiosImagePrivate.interceptors.request.use(
            config => {
                if (!config.headers['Authorization']) {
                    config.headers['Authorization'] = `Bearer ${auth?.accessToken}`;
                }
                return config;
            }, (error) => Promise.reject(error)
        );

        const responseIntercept = axiosImagePrivate.interceptors.response.use(
            response => response,
            async (error) => {
                const prevRequest = error?.config;
                if (error?.response?.status === 401 && !prevRequest?.sent) {
                    prevRequest.sent = true;
                    const newAccessToken = await refresh();
                    if(newAccessToken !== 'notoken') {
                        prevRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
                    }
                    return axiosImagePrivate(prevRequest);
                }
                return Promise.reject(error);
            }
        );

        return () => {
            axiosImagePrivate.interceptors.request.eject(requestIntercept);
            axiosImagePrivate.interceptors.response.eject(responseIntercept);
        }
    }, [auth, refresh])

    return axiosImagePrivate;
}

export default useAxiosImagePrivate;